import React, { useState, useCallback, useEffect } from "react";
import { Card, Button } from "react-bootstrap";
import { FileText, Trash, Upload } from "react-bootstrap-icons";
import { useDropzone } from "react-dropzone";
import { Controller } from "react-hook-form";
import * as XLSX from "xlsx";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import {
  handleResetExcel,
  setExcelData,
  setIsExcelValid,
  setValidationExcelErrors,
} from "../config/claimSlice.js";
import CustomWizardModal from "components/wizard/CustomWizardModal.jsx";
import ValidationExcelModal from "components/wizard/ValidationExcelModal.js";
import {
  timeInstructionFullList,
  selcectionAbsenceReasonFullList,
  routeFullList,
  doseUnitFullList,
  medicationAbsenceCodeFullList,
  MedicationServiceTypeFullList,
  serviceTypeFullList,
  maritalStatusFullList,
  religionFullList,
  dischargeSpecialtyFullList,
  claimTypeFullList,
  claimSubTypeFullList,
  identifierTypeFullList,
  REQUIRED_FIELDS,
  REQUIRED_HEADER,
  REQUIRED_SHEETS,
  opticalDurationList,
  prismList,
  backcurveList,
  diameterList,
  powerList,
  axisList,
  addList,
  contactLenseTypeList,
  lensSpecificationList,
  regularLenseTypeList,
  productTypeList,
  onAdmissionList,
  conditionOnsetList,
  diagtypeCodesList,
  durationUnitList,
  pharmacySubstitueList,
  bodySubSiteList,
  toothSurfaceList,
  bodySiteList,
  roleList,
  relationshipList,
  missingToothReason,
  missingToothNumberList,
  accidentTypeList,
  encounterStatusList,
  dischargeDispositionList,
  admitSourceList,
  encounterClassList,
  intendLengthStayList,
  emergencyDepartmentDispositionList,
  serviceEventTypeList,
  emergencyArrivalCodeList,
  occupationList,
  triageCategoryList,
  departmentDispositionList,
  careTypeList,
  isNewBornList,
  visitTypeList,
  genderList,
  nationalityList,
} from "../utils.js";
const identifierTypeList = identifierTypeFullList.map(
  (item) => item.ident_type_name
);
const claimTypeList = [
  ...claimTypeFullList.map((item) => item.claim_types_code),
  ...claimTypeFullList.map((item) => item.claim_types_name),
  ...claimTypeFullList.map((item) => item.claim_types_id.toString()),
];
const claimSubTypeList = [
  ...claimSubTypeFullList.map((item) => item.claimsub_types_code),
  ...claimSubTypeFullList.map((item) => item.claimsub_types_name),
  ...claimSubTypeFullList.map((item) => item.claimsub_types_id.toString()),
];
const specialityList = dischargeSpecialtyFullList.map(
  (item) => item.specialities_name
);
const religionList = religionFullList.map((item) => item.religion_name);
const maritalStatusList = maritalStatusFullList.map(
  (item) => item.maritalstatus_disply
);
const serviceTypeList = serviceTypeFullList.map((item) => item.servtype_name);
const medicationServiceTypeList = MedicationServiceTypeFullList.map(
  (item) => item.servtype_name
);
const absenceReasonList = medicationAbsenceCodeFullList.map(
  (item) => item.absrsn_name
);
const selectReasonList = selcectionAbsenceReasonFullList.map(
  (item) => item.pharmselrsn_disply
);
const doseList = doseUnitFullList.map((item) => item.ucumtype_name);
const routeList = routeFullList.map((item) => item.ruteadmn_name);
const timeInstructionList = timeInstructionFullList.map(
  (item) => item.time_instDisplay
);
// Maps for code mapping
const identifierTypeCodeMap = new Map();
identifierTypeFullList.forEach((item) => {
  if (item.ident_type_name)
    identifierTypeCodeMap.set(
      item.ident_type_name.toLowerCase(),
      item.ident_type_id
    );
  if (item.ident_type_id)
    identifierTypeCodeMap.set(item.ident_type_id.toString(), item.ident_type_id);
});

const claimSubTypeCodeMap = new Map();
claimSubTypeFullList.forEach((item) => {
  if (item.claimsub_types_code)
    claimSubTypeCodeMap.set(
      item.claimsub_types_code.toLowerCase(),
      item.claimsub_types_id
    );
  if (item.claimsub_types_name)
    claimSubTypeCodeMap.set(
      item.claimsub_types_name.toLowerCase(),
      item.claimsub_types_id
    );
  if (item.claimsub_types_id)
    claimSubTypeCodeMap.set(
      item.claimsub_types_id.toString(),
      item.claimsub_types_id
    );
});

const claimTypeCodeMap = new Map();
claimTypeFullList.forEach((item) => {
  if (item.claim_types_name)
    claimTypeCodeMap.set(
      item.claim_types_name.toLowerCase(),
      item.claim_types_id
    );
  if (item.claim_types_code)
    claimTypeCodeMap.set(
      item.claim_types_code.toLowerCase(),
      item.claim_types_id
    );
  if (item.claim_types_id)
    claimTypeCodeMap.set(item.claim_types_id.toString(), item.claim_types_id);
});
const specialityCodeMap = new Map(
  dischargeSpecialtyFullList.map((item) => [
    item.specialities_name.toLowerCase(),
    item.specialities_code,
  ])
);
const religionCodeMap = new Map(
  religionFullList.map((item) => [
    item.religion_name.toLowerCase(),
    item.religion_code,
  ])
);
const maritalStatusCodeMap = new Map(
  maritalStatusFullList.map((item) => [
    item.maritalstatus_disply.toLowerCase(),
    item.maritalstatus_code,
  ])
);
const serviceTypeCodeMap = new Map(
  serviceTypeFullList.map((item) => [
    item.servtype_name.toLowerCase(),
    item.servtype_code,
  ])
);
const medServiceTypeCodeMap = new Map(
  MedicationServiceTypeFullList.map((item) => [
    item.servtype_name.toLowerCase(),
    item.servtype_code,
  ])
);
const absenceReasonCodeMap = new Map(
  medicationAbsenceCodeFullList.map((item) => [
    item.absrsn_name.toLowerCase(),
    item.absrsn_code,
  ])
);
const selectionReasonCodeMap = new Map(
  selcectionAbsenceReasonFullList.map((item) => [
    item.pharmselrsn_disply.toLowerCase(),
    item.pharmselrsn_code,
  ])
);
const doseUnitCodeMap = new Map(
  doseUnitFullList.map((item) => [
    item.ucumtype_name.toLowerCase(),
    item.ucumtype_code,
  ])
);
const routeCodeMap = new Map(
  routeFullList.map((item) => [
    item.ruteadmn_name.toLowerCase(),
    item.ruteadmn_code,
  ])
);
const timeInstCodeMap = new Map(
  timeInstructionFullList.map((item) => [
    item.time_instDisplay.toLowerCase(),
    item.time_instCode,
  ])
);

const ClaimExcelUpload = ({
  control,
  watch,
  setValue,
  name = "excelFile",
  file,
  setFile,
}) => {
  const dispatch = useDispatch();

  const [excelBuffer, setExcelBuffer] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [showValidationModal, setShowValidationModal] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const payer = watch("payer");
  const validateHeaders = (headers, sheetName) => {
    if (!REQUIRED_SHEETS?.includes(sheetName)) {
      setValue(name, "");
      return true;
    } // Optional sheet
    return REQUIRED_HEADER[sheetName]?.every((field) =>
      headers.includes(field)
    );
  };
  const isValidDateFormat = (dateStr) => {
    const regex = /^\d{4}-\d{2}-\d{2}$/;
    if (!regex.test(dateStr)) return false;
    const date = new Date(dateStr);
    return date instanceof Date && !isNaN(date);
  };
  const normalizeDates = (row, sheetName) => {
    const updatedRow = { ...row };
    REQUIRED_HEADER[sheetName]?.forEach((field) => {
      if (field?.toLowerCase().includes("date")) {
        let val = updatedRow[field];
        if (typeof val == "number") {
          const date = new Date((val - 25569) * 86400 * 1000);
          if (!isNaN(date.getTime())) {
            updatedRow[field] = date.toISOString().slice(0, 10);
          } else {
            updatedRow[field] = ""; // Invalid serial date
          }
        } else if (val) {
          updatedRow[field] = val.toString().trim();
        }
      }
    });
    return updatedRow;
  };
  const validateRow = (
    row,
    sheetName,
    mainData = [],
    claimTypeMap = new Map(),
    rowNum,
    isNCHI
  ) => {
    if (!REQUIRED_SHEETS?.includes(sheetName)) {
      return [];
    }
    const rowErrors = [];
    const claimSeqNo = row?.Claim_Seq_No
      ? String(row.Claim_Seq_No).trim()
      : "missing";
    const displayId =
      claimSeqNo !== "missing" ? `Claim Seq No ${claimSeqNo}` : `row ${rowNum}`;
    // Check for required fields not empty (excluding Optical unless Product_Type exists)
    const requiredFields = REQUIRED_FIELDS[sheetName] || [];
    requiredFields?.forEach((field) => {
      if (
        isNCHI &&
        (field == "Patient_IdentifierType" ||
          field == "Patient_ID" ||
          field == "EncounterClass" ||
          field == "EncounterStatus" ||
          field == "Visit_Type")
      ) {
        return;
      }
      if (!row[field]?.toString().trim()) {
        const humanField = field.replace(/_/g, " ");
        rowErrors.push({
          field,
          message: `${humanField} is missing in ${sheetName} sheet for ${displayId}`,
        });
      }
    });
    // Additional validations for date fields
    REQUIRED_HEADER[sheetName].forEach((field) => {
      const value = row[field]?.toString().trim();
      if (
        value &&
        field?.toLowerCase().includes("date") &&
        field !== "PrescriptionDate"
      ) {
        if (!isValidDateFormat(value)) {
          const humanField = field.replace(/_/g, " ");
          rowErrors.push({
            field,
            message: `${humanField} must be in YYYY-MM-DD format in ${sheetName} sheet for ${displayId}`,
          });
        }
      }
    });
    if (sheetName == "Main") {
      console.log("Main Here");
      const visitType = row.Visit_Type?.toLowerCase();

      if (isNCHI) {
        // NCHI-specific rules
        if (row.Claim_Type?.toLowerCase() !== "institutional") {
          rowErrors.push({
            field: "Claim_Type",
            message: `[NCHI Rule] Claim Type must be institutional in ${sheetName} sheet for ${displayId}`,
          });
        }
        if (row.Claim_Sub_Type?.toLowerCase() !== "ip") {
          rowErrors.push({
            field: "Claim_Sub_Type",
            message: `[NCHI Rule] Claim Sub Type must be ip in ${sheetName} sheet for ${displayId}`,
          });
        }
        if (visitType && visitType !== "referral") {
          rowErrors.push({
            field: "Visit_Type",
            message: `[NCHI Rule] If Visit Type exists, it must be referral in ${sheetName} sheet for ${displayId}`,
          });
        }
        if (!row.PrescriptionRefNo) {
          rowErrors.push({
            field: "PrescriptionRefNo",
            message: `[NCHI Rule] Prescription Ref No is required in ${sheetName} sheet for ${displayId}`,
          });
        }
        if (!String(row.Patient_File_No || "").trim()) {
          rowErrors.push({
            field: "Patient_File_No",
            message: `[NCHI Rule] Patient MRN is required in ${sheetName} sheet for ${displayId}`,
          });
        }
        if (!row.Newborn_MRN) {
          rowErrors.push({
            field: "Newborn_MRN",
            message: `[NCHI Rule] Newborn MRN is required in ${sheetName} sheet for ${displayId}`,
          });
        }
        if (!row.BeneficiaryMRN) {
          rowErrors.push({
            field: "BeneficiaryMRN",
            message: `[NCHI Rule] Beneficiary MRN is required in ${sheetName} sheet for ${displayId}`,
          });
        }
        if (!row.MobileNumber) {
          rowErrors.push({
            field: "MobileNumber",
            message: `[NCHI Rule] Mobile Number is required in ${sheetName} sheet for ${displayId}`,
          });
        }
        if (!row.Nationality) {
          rowErrors.push({
            field: "Nationality",
            message: `[NCHI Rule] Nationality is required in ${sheetName} sheet for ${displayId}`,
          });
        }
        const arabicRegex = /[\u0600-\u06FF]/;
        const patientName = String(row.Patient_Name) || "";
        if (!arabicRegex.test(patientName)) {
          rowErrors.push({
            field: "Patient_Name",
            message: `[NCHI Rule] Patient Name must be in Arabic in ${sheetName} sheet for ${displayId}`,
          });
        }
        const benFirstName = row.BeneficiaryFirstName || "";
        if (!arabicRegex.test(benFirstName)) {
          rowErrors.push({
            field: "BeneficiaryFirstName",
            message: `[NCHI Rule] Beneficiary First Name must be in Arabic in ${sheetName} sheet for ${displayId}`,
          });
        }
        const benLastName = row.BeneficiaryLastName || "";
        if (!arabicRegex.test(benLastName)) {
          rowErrors.push({
            field: "BeneficiaryLastName",
            message: `[NCHI Rule] Beneficiary Last Name must be in Arabic in ${sheetName} sheet for ${displayId}`,
          });
        }
        if (!row.TriageDate) {
          rowErrors.push({
            field: "TriageDate",
            message: `[NCHI Rule] Triage Date is required in ${sheetName} sheet for ${displayId}`,
          });
        }
        if (!row.TriageCategoryType) {
          rowErrors.push({
            field: "TriageCategoryType",
            message: `[NCHI Rule] Triage Category is required in ${sheetName} sheet for ${displayId}`,
          });
        }
        if (!row.EmergencyArrivalCode) {
          rowErrors.push({
            field: "EmergencyArrivalCode",
            message: `[NCHI Rule] Emergency Arrival Code is required in ${sheetName} sheet for ${displayId}`,
          });
        }
      }

      if (
        visitType?.toLowerCase() === "referral" &&
        !row.PrescriptionRefNo?.toString().trim()
      ) {
        rowErrors.push({
          field: "PrescriptionRefNo",
          message: `PrescriptionRefNo is required when visit type is 'referral' in Main sheet for ${displayId}`,
        });
      }
      // Claim type and sub type conditions
      const claimType = row.Claim_Type?.toString().trim()?.toLowerCase();
      const subType = row.Claim_Sub_Type?.toString().trim()?.toLowerCase();
      const dobStr = row.Patient_DateofBirth?.toString().trim();
      // ——————— NEW: IsPrescription == 'Y' → Force fields REQUIRED (even for non-institutional) ———————
      const isPrescriptionVal = row.IsPrescription?.toString()
        .trim()
        .toUpperCase();
      const originalClaimType = row.originalClaimType || claimType;
      const isVision = originalClaimType === "vision";
      const isPharmacy = originalClaimType === "pharmacy";
      if (isPrescriptionVal === "Y") {
        const prescriptionRequiredFields = [
          "AdmissionDate",
          "DischargeDate",
          "EncounterClass",
          "EncounterAdmitSource",
          "DischargeDisposition",
          "EncounterStatus",
          "EmergencyDepartmentDisposition",
          "EmergencyArrivalCode",
          "EmergencyServiceStartDate",
          "TriageDate",
          "TriageCategoryType",
          "DischargeSpeciality",
          "CareType",
          "ServiceEventType",
          "CauseOfDeath",
          "IntendedLengthOfStay",
          "EstimatedLengthOfStay",
        ];
        // Special handling for Vision + Pharmacy
        prescriptionRequiredFields.forEach((field) => {
          // Skip Vision-specific skip if claim is Vision
          if (
            isVision &&
            isPharmacy &&
            isPrescriptionVal === "Y" &&
            field === "IntendedLengthOfStay"
          )
            return;
          if (
            isVision &&
            isPharmacy &&
            isPrescriptionVal === "Y" &&
            field === "EstimatedLengthOfStay"
          )
            return;
          if (isVision || isPharmacy || isPrescriptionVal === "Y") {
            const skipForVisionPharmacy = [
              "AdmissionDate",
              "DischargeDate",
              "EncounterAdmitSource",
              "EmergencyArrivalCode",
              "EmergencyServiceStartDate",
              "TriageDate",
              "TriageCategoryType",
              "CauseOfDeath",
              "IntendedLengthOfStay",
              "EstimatedLengthOfStay",
            ];
            if (skipForVisionPharmacy.includes(field)) return;
          }
        });
      }
      if (dobStr) {
        if (isValidDateFormat(dobStr)) {
          const dob = new Date(dobStr);
          const today = new Date();
          today.setHours(0, 0, 0, 0);
          if (dob > today) {
            rowErrors.push({
              field: "Patient_DateofBirth",
              message: `Patient Date of Birth cannot be in the future (provided: ${dobStr}) in Main sheet for ${displayId}`,
            });
          }
        } else {
          rowErrors.push({
            field: "Patient_DateofBirth",
            message: `Patient Date of Birth must be in YYYY-MM-DD format in Main sheet for ${displayId}`,
          });
        }
      }

      // New Condition: If Claim Type is institutional and Patient Age < 1 year, Birth_Weight is required
      if (claimType === "institutional") {
        let isLessThanOneYear = false;

        if (dobStr && isValidDateFormat(dobStr)) {
          const dob = new Date(dobStr);
          const today = new Date();
          const diffTime = Math.abs(today - dob);
          const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
          // Check if age is less than 365 days (1 year)
          if (diffDays < 365) {
            isLessThanOneYear = true;
          }
        }

        if (isLessThanOneYear && !row.Birth_Weight?.toString().trim()) {
          rowErrors.push({
            field: "Birth_Weight",
            message: `Birth Weight is required for institutional claims when patient is under 1 year old in ${sheetName} sheet for ${displayId}`,
          });
        }
      }

      // New Condition: If Is_Newborn is Y
      const isNewbornVal = row.Is_Newborn?.toString().trim().toUpperCase();
      if (isNewbornVal === "Y") {
        const relationship = row.Relationship?.toString().trim().toLowerCase();
        if (relationship !== "child") {
          rowErrors.push({
            field: "Relationship",
            message: `Relationship must be 'Child' when Is Newborn is 'Y' in Main sheet for ${displayId}`,
          });
        }
        const newbornRequireFields = [
          "BeneficiaryMRN",
          "BeneficiaryGender",
          "BeneficiaryFirstName",
          "BeneficiaryLastName",
          "BeneficiaryBirthDate",
        ];
        newbornRequireFields.forEach((field) => {
          if (!row[field]?.toString().trim()) {
            const humanField = field.replace(/([A-Z])/g, " $1").trim();
            rowErrors.push({
              field,
              message: `${humanField} is required when Is Newborn is 'Y' in Main sheet for ${displayId}`,
            });
          }
        });
      }

      if (!subType) {
        rowErrors.push({
          field: "Claim_Sub_Type",
          message: `Claim Sub Type is missing in Main sheet for ${displayId}`,
        });
      } else {
        if (claimType && claimType == "institutional" && subType !== "ip") {
          rowErrors.push({
            field: "Claim_Sub_Type",
            message: `Claim Sub Type must be 'ip' for institutional claims in Main sheet for ${displayId}`,
          });
        }
        if (claimType && claimType == "professional" && subType == "ip") {
          rowErrors.push({
            field: "Claim_Sub_Type",
            message: `Claim Sub Type cannot be 'ip' for professional claims in Main sheet for ${displayId}`,
          });
        }
        if (
          claimType &&
          claimType !== "institutional" &&
          claimType !== "professional" &&
          subType !== "op"
        ) {
          rowErrors.push({
            field: "Claim_Sub_Type",
            message: `Claim Sub Type must be 'op' for non-institutional claims in Main sheet for ${displayId}`,
          });
        }
      }

      if (claimType != "professional" && isPrescriptionVal == "Y") {
        rowErrors.push({
          field: "Claim Type ",
          message: `When is Prescription is enable so Claim type must be 'proferssional'`,
        });
      }
      if (subType != "op" && isPrescriptionVal == "Y") {
        rowErrors.push({
          field: "Claim Type ",
          message: `When is Prescription is enable so Claim sub type must be 'op'`,
        });
      }

      // Admission Date, Encounter Class, and Encounter Status validation for institutional, professional, and oral
      if (
        (claimType === "institutional" ||
          claimType === "professional" ||
          claimType === "oral")
      ) {
        if (!row.AdmissionDate?.toString().trim()) {
          rowErrors.push({
            field: "AdmissionDate",
            message: `Admission Date is required for ${claimType} claims in Main sheet for ${displayId}`,
          });
        }
        if (!row.EncounterClass?.toString().trim()) {
          rowErrors.push({
            field: "EncounterClass",
            message: `Encounter Class is required for ${claimType} claims in Main sheet for ${displayId}`,
          });
        }
        if (!row.EncounterStatus?.toString().trim()) {
          rowErrors.push({
            field: "EncounterStatus",
            message: `Encounter Status is required for ${claimType} claims in Main sheet for ${displayId}`,
          });
        }
      }

      // Institutional-specific validations
      if (claimType == "institutional" && isPrescriptionVal != "Y") {
        const institutionalFields = [
          "EncounterAdmitSource",
          "IntendedLengthOfStay",
          "EstimatedLengthOfStay",
        ];
        institutionalFields.forEach((field) => {
          if (!row[field]?.toString().trim()) {
            const humanField = field.replace(/_/g, " ");
            rowErrors.push({
              field,
              message: `${humanField} is required for institutional claims in Main sheet for ${displayId}`,
            });
          }
        });
      }
      // Professional-specific validations
      if (claimType == "professional" && isPrescriptionVal != "Y") {
        if (subType == "op") {
          // Professional with op sub-type
          const professionalOpFields = ["ServiceEventType"];
          professionalOpFields.forEach((field) => {
            if (!row[field]?.toString().trim()) {
              const humanField = field.replace(/_/g, " ");
              rowErrors.push({
                field,
                message: `${humanField} is required for professional claims with 'op' sub-type in Main sheet for ${displayId}`,
              });
            }
          });
        } else {
          // Professional with non-op sub-type (ip or emr)
          const professionalNonOpFields = [
            "ServiceEventType",
            "EmergencyArrivalCode",
            "EmergencyServiceStartDate",
            "TriageCategoryType",
            "TriageDate",
            "EmergencyDepartmentDisposition",
          ];
          professionalNonOpFields.forEach((field) => {
            if (!row[field]?.toString().trim()) {
              const humanField = field.replace(/_/g, " ");
              rowErrors.push({
                field,
                message: `${humanField} is required for professional claims with non-'op' sub-type in Main sheet for ${displayId}`,
              });
            }
          });
        }
      }
      // Oral-specific validations
      if (claimType == "oral" && isPrescriptionVal != "Y") {
        const oralFields = ["ServiceEventType"];
        oralFields.forEach((field) => {
          if (!row[field]?.toString().trim()) {
            const humanField = field.replace(/_/g, " ");
            rowErrors.push({
              field,
              message: `${humanField} is required for oral claims in Main sheet for ${displayId}`,
            });
          }
        });
      }
      // CauseOfDeath validation for professional and oral claims
      const dischargeDisposition = row.DischargeDisposition?.toString()
        .trim()
        ?.toLowerCase();
      const emergencyDisposition =
        row.EmergencyDepartmentDisposition?.toString().trim()?.toLowerCase();
      if (
        (claimType == "professional" || claimType == "oral") &&
        (dischargeDisposition == "died" ||
          emergencyDisposition == "ded" ||
          emergencyDisposition == "doa") &&
        !row.CauseOfDeath?.toString().trim()
      ) {
        rowErrors.push({
          field: "CauseOfDeath",
          message: `Cause of Death is required when Discharge Disposition is 'died' or Emergency Department Disposition is 'DED' or 'DOA' in Main sheet for ${displayId}`,
        });
      }
      // Discharge-related validations
      const dischargeFields = [
        "DischargeDisposition",
        "DischargeSpeciality",
        "EmergencyDepartmentDisposition",
      ];
      const hasDischargeField = dischargeFields.some((field) =>
        row[field]?.toString().trim()
      );
      // Rule 1: DischargeDate required if any discharge field exists
      if (hasDischargeField && !row.DischargeDate?.toString().trim()) {
        rowErrors.push({
          field: "DischargeDate",
          message: `Discharge Date is required when Discharge Disposition, Discharge Speciality, or Emergency Department Disposition is provided in Main sheet for ${displayId}`,
        });
      }
      // Rule 2: CauseOfDeath required for institutional claims
      if (claimType == "institutional") {
        const dischargeDisposition = row.DischargeDisposition?.toString()
          .trim()
          ?.toLowerCase();
        const emergencyDisposition =
          row.EmergencyDepartmentDisposition?.toString().trim()?.toLowerCase();
        if (
          (dischargeDisposition == "died" ||
            emergencyDisposition == "ded" ||
            emergencyDisposition == "doa") &&
          !row.CauseOfDeath?.toString().trim()
        ) {
          rowErrors.push({
            field: "CauseOfDeath",
            message: `Cause of Death is required when Discharge Disposition is 'died' or Emergency Department Disposition is 'DED' or 'DOA' in Main sheet for ${displayId}`,
          });
        }
      }
      if (!isNCHI) {
        // Rule 3: DischargeSpeciality required if DischargeDate or DischargeDisposition exists
        if (
          (row.DischargeDate?.toString().trim() || dischargeDisposition) &&
          !row.DischargeSpeciality?.toString().trim()
        ) {
          rowErrors.push({
            field: "DischargeSpeciality",
            message: `Discharge Speciality is required when Discharge Date or Discharge Disposition is provided in Main sheet for ${displayId}`,
          });
        }
        // Rule 4: DischargeDisposition required if DischargeDate or DischargeSpeciality exists
        if (
          (row.DischargeDate?.toString().trim() ||
            row.DischargeSpeciality?.toString().trim()) &&
          !dischargeDisposition
        ) {
          rowErrors.push({
            field: "DischargeDisposition",
            message: `Discharge Disposition is required when Discharge Date or Discharge Speciality is provided in Main sheet for ${displayId}`,
          });
        }
      }
      // Range validations
      const rangeValidations = {
        Temperature: { min: 34.5, max: 46.5 },
        Respiratory_rate: { min: 10, max: 70 },
        OxygenSaturation: { min: 0, max: 100 },
        "Systolic_B.P": { min: 40, max: 150 },
        Height: { min: 1, max: 275.5 },
        Weight: { min: 1, max: 635.5 },
        Pulse: { min: 40, max: 220 },
      };
      Object.keys(rangeValidations).forEach((field) => {
        const value = parseFloat(row[field]?.toString().trim());
        if (!isNaN(value)) {
          const { min, max } = rangeValidations[field];
          if (value < min || value > max) {
            const humanField = field.replace(/_/g, " ");
            rowErrors.push({
              field,
              message: `${humanField} must be between ${min} and ${max} in ${sheetName} sheet for ${displayId}`,
            });
          }
        } else if (row[field]?.toString().trim()) {
          const humanField = field.replace(/_/g, " ");
          rowErrors.push({
            field,
            message: `${humanField} must be a valid number in ${sheetName} sheet for ${displayId}`,
          });
        }
      });
      // List validations
      const fieldLists = {
        Patient_IdentifierType: identifierTypeList,
        Nationality: nationalityList,
        Claim_Type: claimTypeList,
        IsPrescription: isNewBornList,
        Claim_Sub_Type: claimSubTypeList,
        Patient_Gender: genderList,
        Is_Newborn: isNewBornList,
        Visit_Type: visitTypeList,
        CareType: careTypeList,
        TriageCategoryType: triageCategoryList,
        DepartmentDisposition: departmentDispositionList,
        Patient_Occupation: occupationList,
        Patient_Religion: religionList,
        Patient_MaritalStatus: maritalStatusList,
        ServiceEventType: serviceEventTypeList,
        EmergencyArrivalCode: emergencyArrivalCodeList,
        EmergencyDepartmentDisposition: emergencyDepartmentDispositionList,
        IntendedLengthOfStay: intendLengthStayList,
        EncounterClass: encounterClassList,
        EncounterAdmitSource: admitSourceList,
        DischargeDisposition: dischargeDispositionList,
        EncounterStatus: encounterStatusList,
        AccidentType: accidentTypeList,
        MissingToothNumber: missingToothNumberList,
        MissingToothReason: missingToothReason,
        DischargeSpeciality: specialityList,
        Relationship: relationshipList,
        ROLE: roleList,
        SPECIALTY: specialityList,
        ServiceType: serviceTypeList,
        MedicationServiceType: medicationServiceTypeList,
        Tooth_No: missingToothNumberList,
        ToothSurface: toothSurfaceList,
        BodySite: bodySiteList,
        BodySubSite: bodySubSiteList,
        IsMaternity: isNewBornList,
        MedicationScientificCodeAbsenceReason: absenceReasonList,
        MedicationSelectionReason: selectReasonList,
        MedicationPharmacySubstitute: pharmacySubstitueList,
        MedicationDurationUnit: durationUnitList,
        MedicationPeriodunit: durationUnitList,
        MedicationDoseunit: doseList,
        MedicationRoute: routeList,
        MedicationTimeInstruction: timeInstructionList,
        DiagnosisType: diagtypeCodesList,
        ConditionOnset: conditionOnsetList,
        OnAdmission: onAdmissionList,
        Product_Type: productTypeList,
        Regular_Lenses_Type: regularLenseTypeList,
        Lense_Specification: lensSpecificationList,
        Contact_Lense_Type: contactLenseTypeList,
        Is_Frame: isNewBornList,
        Right_Add: addList,
        Left_Add: addList,
        Right_Eye_Distance_SPH: addList,
        Left_Eye_Distance_SPH: addList,
        Left_Eye_Near_SPH: addList,
        Right_Eye_Near_SPH: addList,
        Right_Eye_Distance_CYL: addList,
        Left_Eye_Distance_CYL: addList,
        Left_Eye_Near_CYL: addList,
        Right_Eye_Near_CYL: addList,
        Right_Eye_Near_SPH: addList,
        Right_Eye_Distance_AXIS: axisList,
        Left_Eye_Distance_AXIS: axisList,
        Left_Eye_Near_AXIS: axisList,
        Right_Eye_Near_AXIS: axisList,
        Right_Eye_Distance_POWER: powerList,
        Left_Eye_Distance_POWER: powerList,
        Left_Eye_Near_POWER: powerList,
        Right_Eye_Near_POWER: powerList,
        Right_Eye_Distance_Diameter: diameterList,
        Left_Eye_Distance_Diameter: diameterList,
        Left_Eye_Near_Diameter: diameterList,
        Right_Eye_Near_Diameter: diameterList,
        Right_Eye_Distance_BackCurve: backcurveList,
        Left_Eye_Distance_BackCurve: backcurveList,
        Left_Eye_Near_BackCurve: backcurveList,
        Right_Eye_Near_BackCurve: backcurveList,
        Right_Eye_Distance_PrimIN: prismList,
        Left_Eye_Distance_PrimIN: prismList,
        Left_Eye_Near_PrimIN: prismList,
        Right_Eye_Near_PrimIN: prismList,
        Right_Eye_Distance_PrismOut: prismList,
        Left_Eye_Distance_PrismOut: prismList,
        Left_Eye_Near_PrismOut: prismList,
        Right_Eye_Near_PrismOut: prismList,
        Right_Eye_Distance_PrismUp: prismList,
        Left_Eye_Distance_PrismUp: prismList,
        Left_Eye_Near_PrismUp: prismList,
        Right_Eye_Near_PrismUp: prismList,
        Right_Eye_Distance_PrismDown: prismList,
        Left_Eye_Distance_PrismDown: prismList,
        Left_Eye_Near_PrismDown: prismList,
        Right_Eye_Near_PrismDown: prismList,
        LeftDurationUnit: opticalDurationList,
        RightDurationUnit: opticalDurationList,
      };
      Object.keys(fieldLists).forEach((field) => {
        const value = row[field]?.toString().trim()?.toLowerCase();
        const listLower = fieldLists[field].map((v) => v?.toLowerCase());
        if (value && !listLower.includes(value)) {
          const humanField = field.replace(/_/g, " ");
          rowErrors.push({
            field,
            message: `${humanField} has an invalid value in ${sheetName} sheet for ${displayId}.`,
          });
        }
      });
      // Additional validations for Patient_ID based on Patient_IdentifierType
      const identifierType = row.Patient_IdentifierType?.toString().trim();
      const patientId = row.Patient_ID?.toString().trim();
      if (patientId) {
        if (identifierType == "Iqama") {
          if (!patientId.startsWith("2")) {
            rowErrors.push({
              field: "Iqama",
              message: `Patient ID must start with 2 for Iqama in Main sheet for ${displayId}`,
            });
          }
          if (patientId.length !== 10 || !/^\d{10}$/.test(patientId)) {
            rowErrors.push({
              field: "Iqama",
              message: `Patient ID must be exactly 10 digits for Iqama in Main sheet for ${displayId}`,
            });
          }
        } else if (identifierType == "National ID") {
          if (!patientId.startsWith("1")) {
            rowErrors.push({
              field: "Patient_ID",
              message: `Patient ID must start with 1 for National ID in Main sheet for ${displayId}`,
            });
          }
          if (patientId.length !== 10 || !/^\d{10}$/.test(patientId)) {
            rowErrors.push({
              field: "Patient_ID",
              message: `Patient ID must be exactly 10 digits for National ID in Main sheet for ${displayId}`,
            });
          }
        } else {
          if (patientId.startsWith("1") || patientId.startsWith("2")) {
            rowErrors.push({
              field: "Patient_ID",
              message: `Patient ID should not start with 1 or 2 for this Identifier Type in Main sheet for ${displayId}`,
            });
          }
        }
      }
    }
    if (sheetName == "Practitioner") {
      console.log("Practitioner Here");

      // List validations for Practitioner
      const fieldLists = {
        SPECIALTY: specialityList,
      };
      Object.keys(fieldLists).forEach((field) => {
        const value = row[field]?.toString().trim()?.toLowerCase();
        const listLower = fieldLists[field].map((v) => v?.toLowerCase());
        if (value && !listLower.includes(value)) {
          const humanField = field.replace(/_/g, " ");
          console.log({ humanField });
          rowErrors.push({
            field,
            message: `${humanField} has an invalid value in ${sheetName} sheet for ${displayId}. Please check the allowed values.`,
          });
        }
      });
    }
    if (sheetName == "Diagnosis") {
      console.log("Diagnosis Here");

      const seq = row.Claim_Seq_No?.toString().trim();
      const claimType = claimTypeMap.get(seq);
      if (claimType == "institutional" && !row.OnAdmission?.toString().trim()) {
        rowErrors.push({
          field: "OnAdmission",
          message: `OnAdmission is required for institutional claims in ${sheetName} sheet for ${displayId}`,
        });
      }
    }
    if (sheetName == "Services") {
      console.log("Services Here");

      // Numeric field validations with explicit error for non-numeric inputs
      const numericFields = [
        "Qty",
        "Unit_Price",
        "Gross_Amount",
        "DiscountPercentage",
        "Net_After_Discount",
        "Deductible",
        "Net_Payable_Amount",
        "PatientVatAmount",
        "NetVatAmount",
      ];
      numericFields.forEach((field) => {
        const value = row[field]?.toString().trim();
        if (!value || isNaN(parseFloat(value))) {
          const humanField = field.replace(/_/g, " ");
          rowErrors.push({
            field,
            message: `${humanField} must be a valid number in ${sheetName} sheet for ${displayId}`,
          });
        }
      });
      const serviceType = row.ServiceType?.toString().trim()?.toLowerCase();
      const claimSeqNoStr = row.Claim_Seq_No?.toString().trim();
      const mainRow = mainData.find(
        (mainRow) => mainRow.Claim_Seq_No?.toString().trim() == claimSeqNoStr
      );

      // Validation: Admission date <= Service date <= Discharge date
      if (mainRow) {


        const admissionDate = mainRow.AdmissionDate?.toString().trim();
        const dischargeDate = mainRow.DischargeDate?.toString().trim();
        const claimDate = mainRow.Claim_Date?.toString().trim();
        const serviceDate = row.Service_date?.toString().trim();
        const claimType = (
          mainRow.originalClaimType || mainRow.Claim_Type
        )?.toString().trim().toLowerCase();

        // if (serviceDate && isValidDateFormat(serviceDate) && claimDate && isValidDateFormat(claimDate)) {
        //   if (serviceDate > claimDate) {
        //     rowErrors.push({
        //       field: "Service_date",
        //       message: `Service Date (${serviceDate}) cannot be after Claim Date (${claimDate}) in Services sheet for ${displayId}`,
        //     });
        //   }
        // }

        if (["institutional", "professional", "oral"].includes(claimType)) {
          if (serviceDate && isValidDateFormat(serviceDate)) {
            // Condition: Admission date must be on or before service date
            if (admissionDate && isValidDateFormat(admissionDate)) {
              if (serviceDate < admissionDate) {
                rowErrors.push({
                  field: "Service_date",
                  message: `Service Date must be on or after Admission Date (${admissionDate}) in Services sheet for ${displayId}`,
                });
              }
            }
            // Condition: Discharge date must be on or after service date
            if (dischargeDate && isValidDateFormat(dischargeDate)) {
              if (serviceDate > dischargeDate) {
                rowErrors.push({
                  field: "Service_date",
                  message: `Service Date must be on or before Discharge Date (${dischargeDate}) in Services sheet for ${displayId}`,
                });
              }
            }
          }
        }
      }

      const isPrescription = mainRow?.IsPrescription?.toString()
        .trim()
        ?.toLowerCase();
      // New validation: If IsPrescription is 'y', ServiceType must be 'Medical Code' or 'herbal'
      if (isPrescription == "y") {
        const allowedServiceTypes = ["medical code", "herbal"];
        if (serviceType && !allowedServiceTypes.includes(serviceType)) {
          rowErrors.push({
            field: "ServiceType",
            message: `ServiceType must be 'Medical Code' or 'herbal' when IsPrescription is 'Y' in Main sheet for ${displayId}`,
          });
        }
      }
      const deductibleStr = row.Deductible?.toString().trim();
      const netAfterDiscountStr = row.Net_Payable_Amount?.toString().trim();
      if (deductibleStr || netAfterDiscountStr) {
        const deductible = parseFloat(deductibleStr) || 0;
        const netAfterDiscount = parseFloat(netAfterDiscountStr) || 0;
        if (!isNaN(deductible) && !isNaN(netAfterDiscount)) {
          if (deductible > netAfterDiscount) {
            rowErrors.push({
              field: "Deductible",
              message: `Deductible (${deductible}) cannot be greater than Net Payable Amount in Main sheet for ${displayId}`,
            });
          }
        }
      }
      if (serviceType == "medical code" || serviceType == "herbal") {
        const conditionalFields =
          isPrescription == "y"
            ? [
              "DaysSupply",
              "DiagnosisCode",
              "MedicationSelectionReason",
              "MedicationStartDate",
              "MedicationEndDate",
              "MedicationDuration",
              "MedicationDurationUnit",
              "MedicationFrequency",
              "MedicationPeriod",
              "MedicationPeriodunit",
              "MedicationDose",
              "MedicationDoseunit",
              "MedicationRoute",
            ]
            : ["DaysSupply", "DiagnosisCode"];
        conditionalFields.forEach((field) => {
          if (!row[field]?.toString().trim()) {
            const humanField = field.replace(/_/g, " ");
            rowErrors.push({
              field,
              message: `${humanField} is required when ServiceType is '${serviceType}'${isPrescription == "y"
                ? " and IsPrescription is 'Y'"
                : isPrescription == "n" || !isPrescription
                  ? " and IsPrescription is 'N' or not present"
                  : ""
                } in ${sheetName} sheet for ${displayId}`,
            });
          }
        });
        // Scientific code or absence reason required
        if (
          !row.MedicationScientificCode?.toString().trim() &&
          !row.MedicationScientificCodeAbsenceReason?.toString().trim()
        ) {
          rowErrors.push({
            field: "MedicationScientificCode",
            message: `Either MedicationScientificCode or MedicationScientificCodeAbsenceReason is required when ServiceType is '${serviceType}' in ${sheetName} sheet for ${displayId}`,
          });
        }
      }
      const absenceReason =
        row.MedicationScientificCodeAbsenceReason?.toString()
          .trim()
          ?.toLowerCase();
      if (
        absenceReason == "others" &&
        !row.MedicationScientificCodeAbsenceReasonOthers?.toString().trim()
      ) {
        rowErrors.push({
          field: "MedicationScientificCodeAbsenceReasonOthers",
          message: `MedicationScientificCodeAbsenceReasonOthers is required when MedicationScientificCodeAbsenceReason is 'Others' in ${sheetName} sheet for ${displayId}`,
        });
      }
      const pharmacySubstitute = row.MedicationPharmacySubstitute?.toString()
        .trim()
        ?.toLowerCase();
      if (
        pharmacySubstitute == "others" &&
        !row.MedicationPharmacySubstituteOther?.toString().trim()
      ) {
        rowErrors.push({
          field: "MedicationPharmacySubstituteOther",
          message: `MedicationPharmacySubstituteOther is required when MedicationPharmacySubstitute is 'Others' in ${sheetName} sheet for ${displayId}`,
        });
      }
    }
    if (sheetName == "Optical") {
      // Check if there is a matching Claim_Seq_No in Main sheet with Claim_Type = "vision"
      console.log("Test Optical ");
      const claimSeqNoStr = row.Claim_Seq_No?.toString().trim();
      const mainRow = mainData.find(
        (mainRow) => mainRow.Claim_Seq_No?.toString().trim() == claimSeqNoStr
      );
      const originalClaimType =
        mainRow?.originalClaimType ||
        mainRow?.Claim_Type?.toString().trim()?.toLowerCase();
      const isVisionClaim = mainRow && originalClaimType == "vision";
      // Only apply validations if Claim_Type is "vision" for the matching Claim_Seq_No
      if (isVisionClaim) {
        const productType = row.Product_Type?.toString().trim()?.toLowerCase();

        // Only apply validations if Product_Type exists
        if (productType) {
          // PrescriptionDate is required and must be in valid format
          const prescriptionDate = row.PrescriptionDate?.toString().trim();
          if (!prescriptionDate) {
            rowErrors.push({
              field: "PrescriptionDate",
              message: `Prescription Date is required when Product Type is provided in ${sheetName} sheet for ${displayId}`,
            });
          } else if (!isValidDateFormat(prescriptionDate)) {
            rowErrors.push({
              field: "PrescriptionDate",
              message: `Prescription Date must be in YYYY-MM-DD format in ${sheetName} sheet for ${displayId}`,
            });
          }
          // Cylinder and Axis pair validation
          const cylinderAxisPairs = [
            ["Left_Eye_Distance_CYL", "Left_Eye_Distance_AXIS"],
            ["Left_Eye_Near_CYL", "Left_Eye_Near_AXIS"],
            ["Right_Eye_Distance_CYL", "Right_Eye_Distance_AXIS"],
            ["Right_Eye_Near_CYL", "Right_Eye_Near_AXIS"],
          ];
          cylinderAxisPairs.forEach(([cylField, axisField]) => {
            const cylValue = row[cylField]?.toString().trim();
            const axisValue = row[axisField]?.toString().trim();
            const hasCyl = cylValue && cylValue !== "";
            const hasAxis = axisValue && axisValue !== "";
            if ((hasCyl && !hasAxis) || (!hasCyl && hasAxis)) {
              const missingField = hasCyl ? axisField : cylField;
              const humanCylField = cylField.replace(/_/g, " ");
              const humanAxisField = axisField.replace(/_/g, " ");
              rowErrors.push({
                field: missingField,
                message: `Both ${humanCylField} and ${humanAxisField} must be provided together in ${sheetName} sheet for ${displayId}`,
              });
            }
          });
          if (productType == "lens") {
            // Sphere validation - require at least one
            const sphereFields = [
              "Left_Eye_Distance_SPH",
              "Left_Eye_Near_SPH",
              "Right_Eye_Distance_SPH",
              "Right_Eye_Near_SPH",
            ];
            const hasAnySphere = sphereFields.some(
              (field) =>
                row[field]?.toString().trim() &&
                row[field]?.toString().trim() !== ""
            );
            if (!hasAnySphere) {
              rowErrors.push({
                field: "Sphere",
                message: `At least one Sphere value is required for lens product type in ${sheetName} sheet for ${displayId}`,
              });
            }
            // Sphere validation with Cylinder or Axis
            cylinderAxisPairs.forEach(([cylField, axisField]) => {
              const cylValue = row[cylField]?.toString().trim();
              const axisValue = row[axisField]?.toString().trim();
              const hasCylOrAxis =
                (cylValue && cylValue !== "") ||
                (axisValue && axisValue !== "");
              if (hasCylOrAxis) {
                const [side, , type] = cylField.split("_");
                const sphereField = `${side}_Eye_${type}_SPH`;
                const sphValue = row[sphereField]?.toString().trim();
                if (sphValue == null || sphValue == "") {
                  const humanSphereField = sphereField.replace(/_/g, " ");
                  rowErrors.push({
                    field: sphereField,
                    message: `Sphere is required when Cylinder or Axis is provided for ${side} ${type} in ${sheetName} sheet for ${displayId}`,
                  });
                }
              }
            });
            // Sphere validation with directional prism
            const directions = ["PrimIN", "PrismOut", "PrismUp", "PrismDown"];
            const sides = ["Left", "Right"];
            const types = ["Distance", "Near"];
            directions.forEach((direction) => {
              sides.forEach((side) => {
                types.forEach((type) => {
                  const dirField = `${side}_Eye_${type}_${direction}`;
                  const sphField = `${side}_Eye_${type}_SPH`;
                  const dirValue = row[dirField]?.toString().trim();
                  const sphValue = row[sphField]?.toString().trim();
                  if (
                    dirValue &&
                    dirValue !== "" &&
                    (sphValue == null || sphValue == "")
                  ) {
                    const humanSphField = sphField.replace(/_/g, " ");
                    rowErrors.push({
                      field: sphField,
                      message: `Sphere is required when a prism direction (${direction}) is provided for ${side} ${type} in ${sheetName} sheet for ${displayId}`,
                    });
                  }
                });
              });
            });
          }
          if (productType == "contact") {
            // Power validation - require at least one
            const powerFields = [
              "Left_Eye_Distance_POWER",
              "Left_Eye_Near_POWER",
              "Right_Eye_Distance_POWER",
              "Right_Eye_Near_POWER",
            ];
            const hasAnyPower = powerFields.some(
              (field) =>
                row[field]?.toString().trim() &&
                row[field]?.toString().trim() !== ""
            );
            if (!hasAnyPower) {
              rowErrors.push({
                field: "Power",
                message: `At least one Power value is required for contact product type in ${sheetName} sheet for ${displayId}`,
              });
            }
            // Power validation with Cylinder or Axis
            cylinderAxisPairs.forEach(([cylField, axisField]) => {
              const cylValue = row[cylField]?.toString().trim();
              const axisValue = row[axisField]?.toString().trim();
              const hasCylOrAxis =
                (cylValue && cylValue !== "") ||
                (axisValue && axisValue !== "");
              if (hasCylOrAxis) {
                const [side, , type] = cylField.split("_");
                const powerField = `${side}_Eye_${type}_POWER`;
                const powerValue = row[powerField]?.toString().trim();
                if (powerValue == null || powerValue == "") {
                  const humanPowerField = powerField.replace(/_/g, " ");
                  rowErrors.push({
                    field: powerField,
                    message: `Power is required when Cylinder or Axis is provided for ${side} ${type} in ${sheetName} sheet for ${displayId}`,
                  });
                }
              }
            });
            // Power validation with Backcurve or Diameter
            const directions = ["BackCurve", "Diameter"];
            const sides = ["Left", "Right"];
            const types = ["Distance", "Near"];
            directions.forEach((direction) => {
              sides.forEach((side) => {
                types.forEach((type) => {
                  const dirField = `${side}_Eye_${type}_${direction}`;
                  const powerField = `${side}_Eye_${type}_POWER`;
                  const dirValue = row[dirField]?.toString().trim();
                  const powerValue = row[powerField]?.toString().trim();
                  if (
                    dirValue &&
                    dirValue !== "" &&
                    (powerValue == null || powerValue == "")
                  ) {
                    const humanPowerField = powerField.replace(/_/g, " ");
                    const humanDirection =
                      direction.charAt(0).toUpperCase() + direction.slice(1);
                    rowErrors.push({
                      field: powerField,
                      message: `Power is required when ${humanDirection} is provided for ${side} ${type} in ${sheetName} sheet for ${displayId}`,
                    });
                  }
                });
              });
            });
          }
        }
      }
    }
    return rowErrors;
  };
  const validateSheetData = (
    jsonData,
    sheetName,
    mainData = [],
    claimTypeMap = new Map(),
    isNCHI
  ) => {
    const errors = [];
    jsonData.forEach((row, index) => {
      const rowNum = index + 1; // Header is row 1
      const rowErrors = validateRow(
        row,
        sheetName,
        mainData,
        claimTypeMap,
        rowNum,
        isNCHI
      );
      if (rowErrors?.length > 0) {
        errors.push(
          ...rowErrors.map((err) => ({ sheet: sheetName, row: rowNum, ...err }))
        );
      }
    });
    return errors;
  };
  const processExcel = useCallback(
    (buffer, currentPayer) => {
      let isValid = true;
      const allData = {};
      const allErrors = [];
      const emptySheets = [];
      const invalidHeaderSheets = [];
      const isNCHI = currentPayer?.insurance_company_id == 41;
      try {
        dispatch(handleResetExcel());
        setModalMessage("");
        setValue(name, "");
        const data = new Uint8Array(buffer);
        const workbook = XLSX.read(data, { type: "array" });
        // Check for required sheets
        const missingSheets = REQUIRED_SHEETS.filter(
          (sheet) => !workbook.SheetNames.includes(sheet)
        );
        if (missingSheets.length > 0) {
          toast.error("Invalid file");
          isValid = false;
          return;
        }
        // Process Main sheet first to make data available for Optical and Services validation
        let mainData = [];
        const claimTypeMap = new Map();
        const mainMap = new Map(); // For quick lookup of main rows by seq
        if (workbook.SheetNames.includes("Main")) {
          const sheet = workbook.Sheets["Main"];
          const rawHeaderRows = XLSX.utils.sheet_to_json(sheet, {
            header: 1,
          });
          const headers = rawHeaderRows[0] || [];
          if (!validateHeaders(headers, "Main")) {
            invalidHeaderSheets.push("Main");
          } else {
            let rawJson = XLSX.utils.sheet_to_json(sheet);
            rawJson = rawJson.map((row) => normalizeDates(row, "Main"));
            rawJson = rawJson.map((row) => {
              const claimTypeLower =
                row.Claim_Type?.toString().trim().toLowerCase() || "";
              row.originalClaimType = claimTypeLower;
              const isPrescriptionVal =
                row.IsPrescription?.toString().trim().toUpperCase() || "";
              const isVision = claimTypeLower === "vision";
              const isPharmacy = claimTypeLower === "pharmacy";
              if (isPrescriptionVal === "Y" && (isVision || isPharmacy)) {
                row.Claim_Type = "professional";
                row.Claim_Sub_Type = "op";
              }
              return row;
            });
            mainData = rawJson.map((row, i) => ({
              id: `${Date.now()}-Main-${i + 1}`,
              ...row,
            }));
            allData["Main"] = mainData;
            const seenSeqNos = new Set();
            mainData.forEach((row, index) => {
              const seq = row.Claim_Seq_No?.toString().trim();
              if (seq) {
                if (seenSeqNos.has(seq)) {
                  allErrors.push({
                    sheet: "Main",
                    row: index + 2,
                    field: "Claim_Seq_No",
                    message: `Claim Seq No '${seq}' is duplicated in Main sheet`,
                  });
                } else {
                  seenSeqNos.add(seq);
                }
                claimTypeMap.set(
                  seq,
                  row.Claim_Type?.toString().trim()?.toLowerCase()
                );
                mainMap.set(seq, row);
              }
            });
            if (mainData.length == 0) {
              emptySheets.push("Main");
            }
            const sheetErrors = validateSheetData(
              mainData,
              "Main",
              mainData,
              claimTypeMap,
              isNCHI
            );
            allErrors.push(...sheetErrors);
          }
        }
        // Process other sheets
        workbook.SheetNames.forEach((sheetName) => {
          if (sheetName == "Main") return; // Already processed
          const isRequired = REQUIRED_SHEETS.includes(sheetName);
          const isOptional = sheetName == "Sheet1";
          if (!isRequired && !isOptional) return; // ignore extra sheets
          const sheet = workbook.Sheets[sheetName];
          const rawHeaderRows = XLSX.utils.sheet_to_json(sheet, {
            header: 1,
          });
          const headers = rawHeaderRows[0] || [];
          if (isRequired && !validateHeaders(headers, sheetName)) {
            invalidHeaderSheets.push(sheetName);
            // return;
          }
          if (isOptional && !validateHeaders(headers, sheetName)) {
            return; // Skip invalid optional
          }
          let rawJson = XLSX.utils.sheet_to_json(sheet);
          let jsonData = [];
          rawJson = rawJson.map((row) => normalizeDates(row, sheetName));
          if (sheetName == "Services") {
            // Filter out rows without Claim_Seq_No or completely empty rows
            rawJson = rawJson.filter((row) => {
              const hasClaimSeqNo = row.Claim_Seq_No?.toString().trim();
              const isNotEmpty = Object.values(row).some(
                (value) => value?.toString().trim() && value !== " "
              );
              return hasClaimSeqNo && isNotEmpty;
            });
            jsonData = rawJson.map((row, i) => ({
              id: `${Date.now()}-${sheetName}-${i + 1}`,
              ...row,
            }));
            // Perform calculations and corrections for Services
            const VAT_RATE = 0.15; // Default 15% for Saudi Arabia (2025 standard)
            jsonData = jsonData.map((row) => {
              const updatedRow = { ...row };
              const claimSeqNoStr = row.Claim_Seq_No?.toString().trim();
              const mainRow = mainData.find(
                (mainRow) =>
                  mainRow.Claim_Seq_No?.toString().trim() == claimSeqNoStr
              );
              const isPrescription = mainRow?.IsPrescription?.toString()
                .trim()
                ?.toLowerCase();
              const numericFields = [
                "Qty",
                "Unit_Price",
                "Gross_Amount",
                "DiscountPercentage",
                "Net_After_Discount",
                "Deductible",
                "Net_Payable_Amount",
                "PatientVatAmount",
                "NetVatAmount",
              ];
              // Check if all numeric fields are valid numbers
              let allNumeric = true;
              numericFields.forEach((field) => {
                const value = updatedRow[field]?.toString().trim();
                if (!value || isNaN(parseFloat(value))) {
                  allNumeric = false;
                }
              });
              if (allNumeric) {
                // Parse numeric fields
                numericFields.forEach((field) => {
                  const value = updatedRow[field]?.toString().trim();
                  updatedRow[field] = parseFloat(value);
                });
                const unitPrice = updatedRow.Unit_Price;
                const qty = updatedRow.Qty;
                const discountPercentage = updatedRow.DiscountPercentage;
                const deductible = updatedRow.Deductible;
                // Step 1: Calculate Gross_Amount if unitPrice and qty provided
                if (unitPrice > 0 && qty > 0) {
                  const calculatedGross = unitPrice * qty;
                  updatedRow.Gross_Amount = calculatedGross; // Override if wrong
                }
                const gross = updatedRow.Gross_Amount;
                // Step 2: Calculate discount amount
                const discountAmount = gross * (discountPercentage / 100);
                const calculatedNetAfterDiscount = gross - discountAmount;
                updatedRow.Net_After_Discount = calculatedNetAfterDiscount; // Override
                // Step 3: Calculate Net_Payable_Amount
                const calculatedNetPayable =
                  calculatedNetAfterDiscount - deductible;
                updatedRow.Net_Payable_Amount = calculatedNetPayable; // Override
                // Step 4: Determine effective VAT rate
                let effectiveVatRate = VAT_RATE;
                const vatIndicator =
                  updatedRow.VatIndicator?.toString().trim()?.toLowerCase() ||
                  "";
                if (!isNaN(parseFloat(vatIndicator))) {
                  effectiveVatRate = parseFloat(vatIndicator) / 100; // If numeric, use as percentage
                } else if (vatIndicator == "15") {
                  effectiveVatRate = VAT_RATE; // Apply default
                } else if (vatIndicator == "0") {
                  effectiveVatRate = 0; // No VAT
                }
                // Step 5: Calculate VAT amounts
                const patientVat = deductible * effectiveVatRate;
                updatedRow.PatientVatAmount = patientVat; // VAT on deductible (patient share)
                const netVat = calculatedNetPayable * effectiveVatRate;
                updatedRow.NetVatAmount = netVat; // VAT on net payable (insurance share)
              }
              return updatedRow;
            });
          } else {
            jsonData = rawJson.map((row, i) => ({
              id: `${Date.now()}-${sheetName}-${i + 1}`,
              ...row,
            }));
          }
          if (isRequired && jsonData.length == 0) {
            emptySheets.push(sheetName);
          }
          const sheetErrors = validateSheetData(
            jsonData,
            sheetName,
            mainData,
            claimTypeMap,
            isNCHI
          );
          allErrors.push(...sheetErrors);
          if (isRequired) {
            allData[sheetName] = jsonData;
          }
        });
        // Map fields to codes
        mainData.forEach((row) => {
          const identTypeLower =
            row.Patient_IdentifierType?.toString().trim()?.toLowerCase() || "";
          if (identifierTypeCodeMap.has(identTypeLower)) {
            row.Patient_IdentifierType =
              identifierTypeCodeMap.get(identTypeLower);
          }
          const claimSubTypeLower =
            row.Claim_Sub_Type?.toString().trim()?.toLowerCase() || "";
          if (claimSubTypeCodeMap.has(claimSubTypeLower)) {
            row.Claim_Sub_Type = claimSubTypeCodeMap.get(claimSubTypeLower);
          }
          const claimTypeLower =
            row.Claim_Type?.toString().trim()?.toLowerCase() || "";
          if (claimTypeCodeMap.has(claimTypeLower)) {
            row.Claim_Type = claimTypeCodeMap.get(claimTypeLower);
          }
          const dischargeSpecLower =
            row.DischargeSpeciality?.toString().trim()?.toLowerCase() || "";
          if (specialityCodeMap.has(dischargeSpecLower)) {
            row.DischargeSpeciality = specialityCodeMap.get(dischargeSpecLower);
          }
          const religionLower =
            row.Patient_Religion?.toString().trim()?.toLowerCase() || "";
          if (religionCodeMap.has(religionLower)) {
            row.Patient_Religion = religionCodeMap.get(religionLower);
          }
          const maritalLower =
            row.Patient_MaritalStatus?.toString().trim()?.toLowerCase() || "";
          if (maritalStatusCodeMap.has(maritalLower)) {
            row.Patient_MaritalStatus = maritalStatusCodeMap.get(maritalLower);
          }
        });
        allData.Practitioner?.forEach((row) => {
          const specLower =
            row.SPECIALTY?.toString().trim()?.toLowerCase() || "";
          if (specialityCodeMap.has(specLower)) {
            row.SPECIALTY = specialityCodeMap.get(specLower);
          }
        });
        allData.Services?.forEach((row) => {
          const servTypeLower =
            row.ServiceType?.toString().trim()?.toLowerCase() || "";
          if (serviceTypeCodeMap.has(servTypeLower)) {
            row.ServiceType = serviceTypeCodeMap.get(servTypeLower);
          }
          const medServTypeLower =
            row.MedicationServiceType?.toString().trim()?.toLowerCase() || "";
          if (medServiceTypeCodeMap.has(medServTypeLower)) {
            row.MedicationServiceType =
              medServiceTypeCodeMap.get(medServTypeLower);
          }
          const absReasonLower =
            row.MedicationScientificCodeAbsenceReason?.toString()
              .trim()
              .toLowerCase() || "";
          if (absenceReasonCodeMap.has(absReasonLower)) {
            row.MedicationScientificCodeAbsenceReason =
              absenceReasonCodeMap.get(absReasonLower);
          }
          const selReasonLower =
            row.MedicationSelectionReason?.toString().trim()?.toLowerCase() ||
            "";
          if (selectionReasonCodeMap.has(selReasonLower)) {
            row.MedicationSelectionReason =
              selectionReasonCodeMap.get(selReasonLower);
          }
          const doseUnitLower =
            row.MedicationDoseunit?.toString().trim()?.toLowerCase() || "";
          if (doseUnitCodeMap.has(doseUnitLower)) {
            row.MedicationDoseunit = doseUnitCodeMap.get(doseUnitLower);
          }
          const routeText = row.MedicationRoute?.toString().trim();
          row.MedicationRouteDisplay = routeText || ""; // keep display

          const routeLower = routeText?.toLowerCase();
          if (routeLower && routeCodeMap.has(routeLower)) {
            row.MedicationRoute = routeCodeMap.get(routeLower); // keep code for API
          }
          const timeText = row.MedicationTimeInstruction?.toString().trim();
          row.MedicationTimeInstructionDisplay = timeText || ""; // keep display

          const timeLower = timeText?.toLowerCase();
          if (timeLower && timeInstCodeMap.has(timeLower)) {
            row.MedicationTimeInstruction = timeInstCodeMap.get(timeLower); // keep code for API
          }
        });
        // Transform allData into the desired structure
        const structuredData = [];
        const claimMap = new Map();
        // Initialize structure for each Claim_Seq_No
        mainData.forEach((mainRow) => {
          const seq = mainRow.Claim_Seq_No?.toString().trim();
          if (seq) {
            claimMap.set(seq, {
              Claim_Seq_No: seq,
              Main: { ...mainRow },
              Practitioner: [],
              Services: [],
              Diagnosis: [],
              Lab: [],
              Rad: [],
              Optical: {},
            });
          }
        });
        // Populate Practitioner
        (allData.Practitioner || []).forEach((row) => {
          const seq = row.Claim_Seq_No?.toString().trim();
          if (seq && claimMap.has(seq)) {
            claimMap.get(seq).Practitioner.push(row);
          }
        });
        // Populate Services
        (allData.Services || []).forEach((row) => {
          const seq = row.Claim_Seq_No?.toString().trim();
          if (seq && claimMap.has(seq)) {
            claimMap.get(seq).Services.push(row);
          }
        });
        // Populate Diagnosis
        (allData.Diagnosis || []).forEach((row) => {
          const seq = row.Claim_Seq_No?.toString().trim();
          if (seq && claimMap.has(seq)) {
            claimMap.get(seq).Diagnosis.push(row);
          }
        });
        // Populate Lab
        (allData.Lab || []).forEach((row) => {
          const seq = row.Claim_Seq_No?.toString().trim();
          if (seq && claimMap.has(seq)) {
            claimMap.get(seq).Lab.push(row);
          }
        });
        // Populate Rad
        (allData.Rad || []).forEach((row) => {
          const seq = row.Claim_Seq_No?.toString().trim();
          if (seq && claimMap.has(seq)) {
            claimMap.get(seq).Rad.push(row);
          }
        });
        // Populate Optical (single object per Claim_Seq_No)
        (allData.Optical || []).forEach((row) => {
          const seq = row.Claim_Seq_No?.toString().trim();
          if (seq && claimMap.has(seq)) {
            claimMap.get(seq).Optical = row;
          }
        });
        // Convert Map to Array
        claimMap.forEach((value) => {
          structuredData.push(value);
        });
        // Cross-sheet validations start here
        // First, populate mainClaimToRow
        const mainClaimToRow = {};
        mainData.forEach((row, index) => {
          const seq = row.Claim_Seq_No?.toString().trim();
          if (seq) {
            mainClaimToRow[seq] = index + 2; // row num
          }
        });
        // Populate servicesByClaim first (moved up for invoice matching)
        const servicesByClaim = {};
        const servicesData = allData.Services || [];
        servicesData.forEach((row, index) => {
          const seq = row.Claim_Seq_No?.toString().trim();
          const rowNum = index + 1;
          if (seq && !mainClaimToRow[seq]) {
            allErrors.push({
              sheet: "Services",
              row: rowNum,
              field: "Claim_Seq_No",
              message: `Claim Seq No ${seq} in Services sheet does not match any entry in Main sheet`,
            });
          }
          if (seq) {
            if (!servicesByClaim[seq]) servicesByClaim[seq] = [];
            servicesByClaim[seq].push({ ...row, rowNum });
          }
        });
        // Now perform Services-specific checks (length and dates)
        Object.keys(mainClaimToRow).forEach((seq) => {
          const services = servicesByClaim[seq] || [];
          const mainRow = mainMap.get(seq);
          const claimType = (
            mainRow?.originalClaimType || mainRow?.Claim_Type
          )?.toString().trim().toLowerCase();

          const mainRowNum = mainClaimToRow[seq];
          const admissionDate = mainRow?.AdmissionDate?.toString().trim();
          const dischargeDate = mainRow?.DischargeDate?.toString().trim();
          const claimDate = mainRow?.Claim_Date?.toString().trim();
          if (services.length == 0) {
            allErrors.push({
              sheet: "Main",
              row: mainRowNum,
              field: "Claim_Seq_No",
              message: `At least one service is required in Services sheet for ${claimType} claims (Claim Seq No ${seq})`,
            });
          }

          // Validate service dates against Claim Date for all types
          services.forEach((service) => {
            const serviceDate = service.Service_date?.toString().trim();
            if (serviceDate && claimDate && serviceDate > claimDate) {
              allErrors.push({
                sheet: "Services",
                row: service.rowNum,
                field: "Service_date",
                message: `Service Date (${serviceDate}) cannot be after Claim Date (${claimDate}) in Services sheet for Claim Seq No ${seq}`,
              });
            }
          });

          if (["institutional", "professional", "oral"].includes(claimType)) {
            // Validate service dates against Admission and Discharge dates
            services.forEach((service) => {
              const serviceDate = service.Service_date?.toString().trim();
              if (serviceDate) {
                if (admissionDate && serviceDate < admissionDate) {
                  allErrors.push({
                    sheet: "Services",
                    row: service.rowNum,
                    field: "Service_date",
                    message: `Service Date must be on or after Admission Date (${admissionDate}) in Services sheet for Claim Seq No ${seq}`,
                  });
                }
                if (dischargeDate && serviceDate > dischargeDate) {
                  allErrors.push({
                    sheet: "Services",
                    row: service.rowNum,
                    field: "Service_date",
                    message: `Service Date must be on or before Discharge Date (${dischargeDate}) in Services sheet for Claim Seq No ${seq}`,
                  });
                }
              }
            });
          }
        });
        // Cross-sheet validation for Practitioner
        const practitionerData = allData.Practitioner || [];
        const practitionerByClaim = {};
        practitionerData.forEach((row, index) => {
          const seq = row.Claim_Seq_No?.toString().trim();
          const rowNum = index + 1;
          if (seq && !mainClaimToRow[seq]) {
            allErrors.push({
              sheet: "Practitioner",
              row: rowNum,
              field: "Claim_Seq_No",
              message: `Claim Seq No ${seq} in Practitioner sheet does not match any entry in Main sheet`,
            });
          }
          if (seq) {
            if (!practitionerByClaim[seq]) practitionerByClaim[seq] = [];
            practitionerByClaim[seq].push(row);
          }
        });
        Object.keys(mainClaimToRow).forEach((seq) => {
          const practitioners = practitionerByClaim[seq] || [];
          if (practitioners.length == 0) {
            allErrors.push({
              sheet: "Main",
              row: mainClaimToRow[seq],
              field: "Claim_Seq_No",
              message: `At least one practitioner is required in Practitioner sheet for Claim Seq No ${seq}`,
            });
          } else {
            const primaryCount = practitioners.filter(
              (p) => p.ROLE?.toString().trim().toUpperCase() == "PRIMARY"
            ).length;
            if (primaryCount !== 1) {
              allErrors.push({
                sheet: "Main",
                row: mainClaimToRow[seq],
                field: "Claim_Seq_No",
                message: `Exactly one practitioner must have the role 'PRIMARY' in Practitioner sheet for Claim Seq No ${seq}`,
              });
            }
          }
        });
        // Cross-sheet validation for Diagnosis
        const diagnosisData = allData.Diagnosis || [];
        const diagnosisByClaim = {};
        diagnosisData.forEach((row, index) => {
          const seq = row.Claim_Seq_No?.toString().trim();
          const rowNum = index + 1;
          if (seq && !mainClaimToRow[seq]) {
            allErrors.push({
              sheet: "Diagnosis",
              row: rowNum,
              field: "Claim_Seq_No",
              message: `Claim Seq No ${seq} in Diagnosis sheet does not match any entry in Main sheet`,
            });
          }
          if (seq) {
            if (!diagnosisByClaim[seq]) diagnosisByClaim[seq] = [];
            diagnosisByClaim[seq].push({ ...row, rowNum });
          }
        });
        Object.keys(mainClaimToRow).forEach((seq) => {
          const diagnoses = diagnosisByClaim[seq] || [];
          const mainRowNum = mainClaimToRow[seq];
          if (diagnoses.length == 0) {
            allErrors.push({
              sheet: "Main",
              row: mainRowNum,
              field: "Claim_Seq_No",
              message: `At least one diagnosis is required in Diagnosis sheet for Claim Seq No ${seq}`,
            });
          } else {
            const principleCount = diagnoses.filter(
              (d) =>
                d.DiagnosisType?.toString().trim()?.toLowerCase() ===
                "principal"
            ).length;
            if (principleCount !== 1) {
              allErrors.push({
                sheet: "Main",
                row: mainRowNum,
                field: "Claim_Seq_No",
                message: `Exactly one diagnosis must have Diagnosis Type 'principal' in Diagnosis sheet for Claim Seq No ${seq}`,
              });
            }
          }
          // Check invoices in diagnosis match services
          diagnoses.forEach((diag) => {
            const invoice = diag.Invoice_No?.toString().trim();
            if (invoice) {
              const servicesForClaim = servicesByClaim[seq] || [];
              const hasMatching = servicesForClaim.some(
                (s) => s.Invoice_No?.toString().trim() == invoice
              );
              if (!hasMatching) {
                allErrors.push({
                  sheet: "Diagnosis",
                  row: diag.rowNum,
                  field: "Invoice_No",
                  message: `Invoice No ${invoice} in Diagnosis sheet does not match any in Services for Claim Seq No ${seq}`,
                });
              }
            }
          });
        });
        // Cross-sheet validation for Lab
        const labData = allData.Lab || [];
        const labByClaim = {};
        labData.forEach((row, index) => {
          const seq = row.Claim_Seq_No?.toString().trim();
          const rowNum = index + 1;
          if (seq) {
            if (!labByClaim[seq]) labByClaim[seq] = [];
            labByClaim[seq].push({ ...row, rowNum });
          }
        });
        Object.keys(labByClaim).forEach((seq) => {
          if (!mainClaimToRow[seq]) return;
          const labs = labByClaim[seq];
          labs.forEach((lab) => {
            const invoice = lab.INVOICE_NO?.toString().trim();
            if (invoice) {
              const servicesForClaim = servicesByClaim[seq] || [];
              const hasMatching = servicesForClaim.some(
                (s) => s.Invoice_No?.toString().trim() == invoice
              );
              if (!hasMatching) {
                allErrors.push({
                  sheet: "Lab",
                  row: lab.rowNum,
                  field: "INVOICE_NO",
                  message: `INVOICE_NO ${invoice} in Lab sheet does not match any in Services for Claim Seq No ${seq}`,
                });
              }
            }
          });
        });
        // Cross-sheet validation for Rad
        const radData = allData.Rad || [];
        const radByClaim = {};
        radData.forEach((row, index) => {
          const seq = row.Claim_Seq_No?.toString().trim();
          const rowNum = index + 1;
          if (seq) {
            if (!radByClaim[seq]) radByClaim[seq] = [];
            radByClaim[seq].push({ ...row, rowNum });
          }
        });
        Object.keys(radByClaim).forEach((seq) => {
          if (!mainClaimToRow[seq]) return;
          const rads = radByClaim[seq];
          rads.forEach((rad) => {
            const invoice = rad.INVOICE_NO?.toString().trim();
            if (invoice) {
              const servicesForClaim = servicesByClaim[seq] || [];
              const hasMatching = servicesForClaim.some(
                (s) => s.Invoice_No?.toString().trim() == invoice
              );
              if (!hasMatching) {
                allErrors.push({
                  sheet: "Rad",
                  row: rad.rowNum,
                  field: "INVOICE_NO",
                  message: `INVOICE_NO ${invoice} in Rad sheet does not match any in Services for Claim Seq No ${seq}`,
                });
              }
            }
          });
        });
        dispatch(setValidationExcelErrors(allErrors));
        if (emptySheets.length == REQUIRED_SHEETS.length) {
          console.log("hhh");
          setModalMessage("The file appears to be empty or corrupted.");
          setShowModal(true);
          dispatch(setExcelData([]));
          dispatch(setValidationExcelErrors([]));
          dispatch(setIsExcelValid(false));
          isValid = false;
        } else if (invalidHeaderSheets.length > 0) {
          setModalMessage(
            "Invalid file format. Please download the standard template."
          );
          setShowModal(true);
          isValid = false;
        } else if (allErrors.length > 0) {
          console.log("hhh12ss3");
          if (allErrors.length < 6) {
            console.log("hhh1sww23");
            setModalMessage(
              allErrors
                .map((e) => `${e.sheet} row ${e.row}: ${e.message} <br />`)
                .join("\n")
            );
            setShowModal(true);
          } else {
            console.log("hhh1wwww23");
            setShowValidationModal(true);
            setModalMessage(
              "Multiple validation errors found. Download report for details."
            );
          }
          isValid = false;
        }
        // — ONLY IF NO ERRORS: Mark as valid —
        if (
          allErrors.length == 0 &&
          invalidHeaderSheets.length == 0 &&
          allData?.Main?.length > 0
        ) {
          dispatch(setExcelData(allData));
          dispatch(setIsExcelValid(true));
          setValue(name, file);
        } else {
          console.log("hhh1ww[5455www]ww23");
          dispatch(setIsExcelValid(false));
          dispatch(setExcelData([]));
          console.log({ allErrors, invalidHeaderSheets });
          // Do NOT clear the file input visually unless you want to
        }
        console.log({ allData });
      } catch (error) {
        console.error("Error reading Excel file:", error);
        toast.error("Error processing Excel file.");
        allErrors.push({ row: 0, message: "Invalid file format." });
        dispatch(setValidationExcelErrors(allErrors));
        isValid = false;
      }
    },
    [dispatch, setValue, name]
  );
  useEffect(() => {
    if (excelBuffer) {
      processExcel(excelBuffer, payer);
    }
  }, [payer, excelBuffer, processExcel]);
  const onDrop = useCallback(
    (acceptedFiles) => {
      dispatch(handleResetExcel());
      const excelFile = acceptedFiles[0];
      const reader = new FileReader();
      reader.onload = (e) => {
        console.log({ excelFile });
        setExcelBuffer(e.target.result);
        setFile(excelFile);
        setValue(name, excelFile);
      };
      reader.onerror = () => {
        toast.error("Error reading file");
        setFile(null);
        setValue(name, null);
      };
      reader.readAsArrayBuffer(excelFile);
    },
    [setValue, name, dispatch]
  );
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: {
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [
        ".xlsx",
      ],
      "application/vnd.ms-excel": [".xls"],
    },
    maxFiles: 1,
  });
  const handleRemove = () => {
    setFile(null);
    setExcelBuffer(null);
    dispatch(setExcelData([]));
    dispatch(setValidationExcelErrors([]));
    dispatch(setIsExcelValid(false));
    setValue(name, null);
  };
  return (
    <>
      <Controller
        name={name}
        control={control}
        render={({ fieldState: { error } }) => (
          <Card className="mt-3">
            <Card.Body>
              <div {...getRootProps({ className: "dropzone-area py-4" })}>
                <input {...getInputProps()} />
                <div className="text-center">
                  <div
                    className="rounded-circle bg-success text-white d-flex align-items-center justify-content-center mx-auto mb-3"
                    style={{ width: 60, height: 60 }}
                  >
                    <Upload size={24} />
                  </div>
                  {isDragActive ? (
                    <p>Drop the Excel file here</p>
                  ) : (
                    <>
                      <h5 className="fw-bold">Upload Your Excel File</h5>
                      <p className="mb-3">
                        Drag and drop your .xlsx spreadsheet here
                      </p>
                      <Button variant="success">Choose File</Button>
                    </>
                  )}
                </div>
              </div>
              {file && (
                <div className="mt-4">
                  <div className="d-flex align-items-center justify-content-between p-3 border rounded">
                    <div className="d-flex align-items-center">
                      <div
                        className="rounded  d-flex align-items-center justify-content-center"
                        style={{ width: 40, height: 40 }}
                      >
                        <FileText className="text-primary" />
                      </div>
                      <div className="ms-3">
                        <h6 className="mb-0">{file.name}</h6>
                        <small className="text-muted">
                          {(file.size / 1024 / 1024).toFixed(2)} MB
                        </small>
                      </div>
                    </div>
                    <Button
                      variant="outline-danger"
                      size="sm"
                      onClick={handleRemove}
                    >
                      <Trash size={16} />
                    </Button>
                  </div>
                </div>
              )}
              {error && (
                <div className="text-danger mt-2">
                  {error.message || "Excel file is required"}
                </div>
              )}
            </Card.Body>
          </Card>
        )}
      />
      <CustomWizardModal
        modal={showModal}
        setModal={setShowModal}
        title="Invalid File"
        description={modalMessage}
      />
      <ValidationExcelModal
        modal={showValidationModal}
        setModal={setShowValidationModal}
        title="Invalid File"
        description={modalMessage}
      />
    </>
  );
};
export default ClaimExcelUpload;
